import { createContext, useContext } from "react";
import { AppxApi } from "../components/App/AppxApi";
import { APP } from "../config";


export const AuthContext = createContext();
export const AuthConsumer = AuthContext.Consumer;
export const AuthProvider = ({ org, theme, themeConfig, config, children }) => {
    const api = new AppxApi();
    const overrideApiParameters = (p) => {
        p.app = APP;
        p.org = org;

        return p;
    };
    const getModelList = async(p) => {
        return await api.getModelList(overrideApiParameters(p));
    };
    const getModelData = async(p) => {
        return await api.getModelData(overrideApiParameters(p));
    };
    const setModelData = async(p) => {
        return await api.setModelData(overrideApiParameters(p));
    };
    const createModelData = async(p) => {
        return await api.createModelData(overrideApiParameters(p));
    };
    const doModelAction = async(p) => {
        return await api.doModelAction(overrideApiParameters(p));
    };

    return (
        <AuthContext.Provider
            value={{
                org: org,
                theme: theme,
                themeConfig: themeConfig,
                config: config,
                getModelList: getModelList,
                getModelData: getModelData,
                createModelData: createModelData,
                setModelData: setModelData,
                doModelAction: doModelAction
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
export const useAuthContext = () => useContext(AuthContext);
